import { convertToRaw, EditorState } from 'draft-js';
import { omit } from 'lodash';
import moment from 'moment';
import { dateFormat, type NoteType, type QLog, type SelectOption } from '@qwealth/qdata';

import type { MeaningfulInteractionForm } from './meaningfulInteraction';

export type QLogRaw = Omit<QLog, 'householdQID'> & {
  pending?: Array<File>;
  householdQID: SelectOption<string> | string;
};

export type QLogForm = MeaningfulInteractionForm<QLogRaw>;

export const toQLog = (rawValues: QLogRaw, editorState: EditorState): QLog => {
  const logContent = JSON.stringify(convertToRaw(editorState.getCurrentContent()));

  let householdQIDValue = '';

  if (typeof rawValues.householdQID === 'object' && 'value' in rawValues.householdQID) {
    householdQIDValue = rawValues.householdQID.value;
  } else if (typeof rawValues.householdQID === 'string') {
    householdQIDValue = rawValues.householdQID;
  } else {
    householdQIDValue = rawValues.owners?.[0] ?? '';
  }

  return {
    ...omit(rawValues, ['pending']),
    content: logContent,
    //@ts-ignore temporary fix for the call log payload -- will fix after qdata update
    householdQID: householdQIDValue,
    owners: [householdQIDValue],
  };
};

export const getInitialCallLog = (email: string, log: Partial<QLog> | null): QLog => {
  return {
    uuid: log?.uuid ?? '',
    content: log?.content ?? '',
    owners: log?.owners ? log.owners : [],
    /* @ts-ignore TODO: remove after version bump */
    relatedMembers: log?.relatedMembers ? log.relatedMembers : [],
    author: log?.author ?? email,
    date: log?.date ?? moment().format(dateFormat),
    lastUpdated: log?.lastUpdated ?? moment().format(dateFormat),
    lastUpdatedBy: log?.author ?? email,
    title: log?.title ?? 'Administration',
    meetingDate: log?.meetingDate ?? moment().format(dateFormat),
    noteType: 'call_log' as NoteType,
    householdName: log?.householdName ?? '',
    householdType: log?.householdType ?? undefined,
    isInternal: log?.isInternal ?? 1,
    isSignificantChange: log?.isSignificantChange ?? 0,
    isMeaningfulInteraction: log?.isMeaningfulInteraction ?? 0,
    isPortfolioReview: log?.isPortfolioReview ?? 0,
  };
};
